export default {
  NEXT_DYNAMIC_PAGE_URL_RESULT: 'NEXT_DYNAMIC_PAGE_URL_RESULT',
  PREVIOUS_DYNAMIC_PAGE_URL_RESULT: 'PREVIOUS_DYNAMIC_PAGE_URL_RESULT',
  INITIALIZE: 'INITIALIZE',
}
